import getValidateMessageInstance, {
  TGetValidateMessage,
  TGetValidateMessageInstance,
} from './getValidateMessageInstance'

export type { TGetValidateMessage, TGetValidateMessageInstance }
export default getValidateMessageInstance
